import { DEAL_STAGE_LABELS, LEAD_STATUS_LABELS, TASK_STATUS_LABELS } from "./labels";

const TASK_STATUS_TEXT = Object.fromEntries(
  Object.entries(TASK_STATUS_LABELS).map(([k, v]) => [k, v.de]),
);
const LEAD_STATUS_TEXT = Object.fromEntries(
  Object.entries(LEAD_STATUS_LABELS).map(([k, v]) => [k, v.de]),
);

const TASK_STATUS_KEYS = Object.keys(TASK_STATUS_TEXT);
const LEAD_STATUS_KEYS = Object.keys(LEAD_STATUS_TEXT);

export function formatActivityDescription(description) {
  if (!description) return description;
  const raw = String(description);

  if (LEAD_STATUS_KEYS.length > 0) {
    const leadPattern = new RegExp(
      `^Lead-Status:\\s*(${LEAD_STATUS_KEYS.join("|")})\\s*→\\s*(${LEAD_STATUS_KEYS.join("|")})\\s*$`
    );
    const leadStatus = raw.match(leadPattern);
    if (leadStatus) {
      const from = LEAD_STATUS_TEXT[leadStatus[1]] || leadStatus[1];
      const to = LEAD_STATUS_TEXT[leadStatus[2]] || leadStatus[2];
      return `Lead-Status: ${from} → ${to}`;
    }
  }

  const pipelineStage = raw.match(/^(?:Pipeline-Stage|Deal-Phase):\s*([A-Z_]+)\s*→\s*([A-Z_]+)\s*$/);
  if (pipelineStage) {
    const from = pipelineStage[1];
    const to = pipelineStage[2];
    const fromLabel = DEAL_STAGE_LABELS[from] || from;
    const toLabel = DEAL_STAGE_LABELS[to] || to;
    return `Deal-Phase: ${fromLabel} → ${toLabel}`;
  }

  if (TASK_STATUS_KEYS.length === 0) return raw;
  const pattern = new RegExp(
    `\\b(${TASK_STATUS_KEYS.join("|")})\\b\\s*→\\s*\\b(${TASK_STATUS_KEYS.join("|")})\\b`,
    "g",
  );

  return raw.replace(pattern, (_match, from, to) => {
    const fromLabel = TASK_STATUS_TEXT[from] || from;
    const toLabel = TASK_STATUS_TEXT[to] || to;
    return `${fromLabel} → ${toLabel}`;
  });
}

